/** @format */

import { AimOutlined, FieldTimeOutlined, MailOutlined, PhoneOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { Col, Row, Space, Typography } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Service } from './services';
import { PixelFacebook } from '../../components/Commons/Hooks/Functions/PixelFacebook';
import { ENV_ADDRESS } from '../../components/Commons/Hooks/Variables/Enviroment';
// import MapLeaft from '../../components/Commons/MapLeaft';
import GoogleMap from '../../components/Commons/Header/components/Address/components/GoogleMap';
import MetaDescription from '../../components/Commons/MetaDescription';
import Spacer from '../../components/Commons/Spacer';
// import { getDayWeek} from '../../v2-config/utils/get-day-week.util';
import { getOpenCloseHours } from '../../v2-config/utils/get-open-close-hours.util';
import { handleScheduleAvailability } from '../../v2-config/utils/handle-schedule-availability.util';
import { MOTIVE } from './constant/motive-constant';
import { getActiveReason } from '../../v2-config/utils/get-active-reason.util';
import { convertUnixToUTC } from '../../v2-config/utils/convert-unix-to-utc.util';
import { isSpecialSchedule } from '../../v2-config/utils/is-special-schedule.util';
import { getSpecialScheduleDate } from '../../v2-config/utils/get-special-schedule-date.util';

import './style.scss';

const { Title, Text } = Typography;

export default function Contact() {
	const { t } = useTranslation('global');
	const [isContactAddress, setContactAddress] = useState(null);
	const [infoPharmacy, setInfoPharmacy] = useState(null);
	const [isLoading, setLoading] = useState(true);

	useEffect(() => {
		PixelFacebook('Contact');
		let address = ENV_ADDRESS.split(',');
		setContactAddress({ lat: parseFloat(address[3]), lng: parseFloat(address[4]) });
	}, []);

	const [isOpen, setIsOpen] = useState(false);

	const toggleDropdown = () => {
		setIsOpen((prev) => !prev);
	};

	useEffect(() => {
		new Service()
			.getPharmacy()
			.then((response) => {
				if (response?.data[0]) {
					console.log('response', response);
					setInfoPharmacy(response.data[0]);
					setLoading(false);
				} else {
					console.log('No hay datos de la farmacia disponibles');
				}
			})
			.catch((error) => {
				console.log('error', error);
			});
	}, []);

	const mapped = (infoPharmacy?.special_schedule || []).map((item) => {
		const start = moment.unix(item.start).utc();
		const end = moment.unix(item.end).utc();

		return {
			id: item._id ?? undefined,
			from: start.format('DD/MM/YY'),
			to: end.format('DD/MM/YY'),
			begin: start.format('HH:mm:ss'),
			end: end.format('HH:mm:ss'),
			motive: item.reason,
		};
	});

	if (isLoading) return null;
	return (
		<>
			<Helmet>
				<MetaDescription title={t('main.metaTitle')} name={'description'} content={t('main.metaContent')} />
			</Helmet>
			<div className="ph-contact-global-container">
				<div className="ph-contact-container">
					<div className="ph-contact-image-container">
						<div className="ph-contact-description-main-container">
							<div className="ph-contact-description-main-container">
								<div className="ph-contact-description-container">
									<Title className="ph-contact-title">¡Contáctanos!</Title>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div className="ph-contact-info-container">
						<Row>
							<Col xs={24} sm={24} md={8} lg={8} xl={8}>
								<div className="ph-contact-info-inner-container">
									<Space direction="vertical" className="ph-contact-info-text-container">
										<Title className="ph-contact-info-title">Información de Contacto:</Title>
										<Space direction="horizontal">
											<AimOutlined className="ph-contact-info-description-icon" />
											<Text className="ph-contact-info-description">{infoPharmacy?.direction + ',' + infoPharmacy?.commune + ',' + infoPharmacy?.region}</Text>
										</Space>
										<Space direction="horizontal">
											<PhoneOutlined className="ph-contact-info-description-icon" />
											<Text className="ph-contact-info-description">{infoPharmacy?.phone}</Text>
										</Space>
										<Space direction="horizontal">
											<MailOutlined className="ph-contact-info-description-icon" />
											<Text className="ph-contact-info-description">{infoPharmacy?.email}</Text>
										</Space>
										<Space direction="horizontal">
											<FieldTimeOutlined className="ph-contact-info-description-icon" />

											{handleScheduleAvailability(infoPharmacy?.schedule) ? (
												<>
													{isSpecialSchedule(infoPharmacy?.special_schedule) ? (
														getActiveReason(infoPharmacy?.special_schedule) === MOTIVE[0] ? (
															<span className="ph-elastic-opening-text">
																<span className="ph-elastic-open-color"> Abierto </span> - Hoy hasta las {getOpenCloseHours(infoPharmacy?.schedule)} :00 hs
																(Cambio de Horario)
															</span>
														) : getActiveReason(infoPharmacy?.special_schedule) === MOTIVE[1] ? (
															<span className="ph-elastic-opening-text">
																<span className="ph-elastic-open-color"> Abierto </span> - Hoy de turno
															</span>
														) : null // Si no coincide con ninguno de los MOTIVE
													) : (
														<span className="ph-elastic-opening-text">
															<span className="ph-elastic-open-color"> Abierto </span> - Hoy hasta las {getOpenCloseHours(infoPharmacy?.schedule)} :00 hs
														</span>
													)}
												</>
											) : // Aquí verificamos si el motivo de "Cerrado" está activo
											isSpecialSchedule(infoPharmacy?.special_schedule) &&
											  getActiveReason(infoPharmacy?.special_schedule)?.toLowerCase().includes('vacaciones') ? (
												<span className="ph-elastic-opening-text">
													<span className="ph-elastic-closed-color">{getActiveReason(infoPharmacy?.special_schedule)}</span> - desde el{' '}
													{convertUnixToUTC(getSpecialScheduleDate(infoPharmacy?.special_schedule, true))} hasta{' '}
													{convertUnixToUTC(getSpecialScheduleDate(infoPharmacy?.special_schedule, false))}
												</span>
											) : getActiveReason(infoPharmacy?.special_schedule)?.toLowerCase().includes('cerrado') ? (
												<span className="ph-elastic-opening-text">
													Hoy estamos <span className="ph-elastic-closed-color"> {getActiveReason(infoPharmacy?.special_schedule).toLowerCase()}</span>
												</span>
											) : (
												<span className="ph-elastic-opening-text">
													<span className="ph-elastic-closed-color"> Cerrado </span> - Abre a las {getOpenCloseHours(infoPharmacy?.schedule)} :00 de mañana
												</span>
											)}

											{isOpen ? (
												<UpOutlined className="ph-elastic-down-icon" onClick={toggleDropdown} />
											) : (
												<DownOutlined className="ph-elastic-down-icon" onClick={toggleDropdown} />
											)}
										</Space>
										<Space>
											{isOpen && (
												<>
													<div>
														{['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'].map((day, index) => (
															<Text className="ph-contact-info-description-days" key={day}>
																{day}: {infoPharmacy?.schedule[index]?.open}
																{infoPharmacy?.schedule[index]?.close === 'CERRADO' ? '' : ` a ${infoPharmacy?.schedule[index]?.close} hs.`}
															</Text>
														))}

														<hr className="hr-special"></hr>

														{mapped.length > 0 ? (
															mapped
																.filter((change) => {
																	const today = moment().startOf('day');
																	const toDate = moment(change.to, 'DD/MM/YY');
																	return toDate.isSameOrAfter(today);
																})
																.map((change, index) => {
																	return (
																		<div key={index} className="ph-contact-info-description-temporal-schedule">
																			{change.motive === MOTIVE[0] ? (
																				<span>
																					{change.from}, {change.begin} a {change.end} hs, {change.motive}
																				</span>
																			) : change.motive === MOTIVE[1] ? (
																				<span className="ph-contact-info-description-temporal-schedule">
																					{change.from}, {change.motive}
																				</span>
																			) : change.from === change.to ? (
																				<span className="ph-contact-info-description-temporal-schedule">
																					{change.from}, {change.motive}
																				</span>
																			) : (
																				<span className="ph-contact-info-description-temporal-schedule">
																					{change.from} - {change.to}, {change.motive}
																				</span>
																			)}
																		</div>
																	);
																})
														) : (
															<span> </span>
														)}
													</div>
												</>
											)}
										</Space>
									</Space>
								</div>
							</Col>
							<Spacer />
							<Col xs={24} sm={24} md={15} lg={15} xl={15} className="ph-contact-col-custom-container">
								<div className="ph-contact-map-container">{isContactAddress && <GoogleMap coordinates={isContactAddress} zoom={16} />}</div>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		</>
	);
}
